// npm
import axios from 'axios';
import Cookies from 'js-cookie';
import { Message } from 'iview';

// constants

import {
  START_REQUEST,
  FINISH_REQUEST,
} from "./constants";
import {
  GET_INDEX_BANNER_ACTION,
  SET_INDEX_BANNER,
  UPDATE_INDEX_BANNER_ACTION
} from "./constants";
import {
  GET_TRAVELAREA_ACTION,
  GET_ACCIDENTAREA_ACTION,
  SET_NOT_ABROAD,
  SET_ABROAD,
  SET_NOT_ACCIDENTABROAD,
  SET_ACCIDENTABROAD,
  UPDATE_ACCIDENTAREA,
  UPDATE_TRAVELAREA,
} from "./constants";
import {
  GET_BRAND_OPTION_ACTION,
  GET_CARSTYLE_OPTION_ACTION,
  GET_CARTYPE_OPTION_ACTION,
  SET_CAR_OPTION_CARTYPE,
  SET_CAR_OPTION_BRAND,
  SET_CAR_OPTION_CARSTYLE,
  SET_MOTOR_OPTION_CARTYPE,
  SET_MOTOR_OPTION_BRAND,
  SET_MOTOR_OPTION_CARSTYLE,
 // GET_CARPROFILE_ACTION
} from "./constants";

const { NODE_ENV } = process.env;
const baseURL = NODE_ENV === 'development' 
  ? 'https://localhost:5000/api/' 
  : 'https://ec.rockgp.com:5001/api/' ;
const ajax = axios.create({ baseURL });

Message.config({
  duration: 15
});
const getTravelArea = async ({ commit }, payload ) => {
  commit(START_REQUEST);
  const token = Cookies.get('accessToken');
  const data = {
    abroad: payload
  }
  
  const config = {
    method: 'post',
    url: 'TravelAcidentInsurance/GetCountries',
    data,
    headers: { Authorization: token }
  };
  
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    
    if (!success) {
      commit(FINISH_REQUEST);
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    commit(FINISH_REQUEST);
    const data = {
      abroad: payload,
      result
    }
    if(payload) {
      commit(SET_ABROAD, data);
    }else{
      commit(SET_NOT_ABROAD, data);
    }
  }
  catch(err) {
    commit(FINISH_REQUEST);
    console.log(err);
  }
}
const getAccidentArea = async ({ commit }, payload ) => {
  commit(START_REQUEST);
  const token = Cookies.get('accessToken');
  /*const data = {
    expectPremium: payload.expectPremium  //202012/28 丟到後端GetJobType 參數
  }*/
  
  const config = {
    method: 'post',
    url: 'AccidentInsurance/GetJobType',  //2020/12/09 Wen modify 
    //data,
    headers: { Authorization: token }
  };
  //console.log(data.expectPremium);
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    
    if (!success) {
      commit(FINISH_REQUEST);
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    commit(FINISH_REQUEST);
    const data = {
      expectPremium: payload,
      result
    }    
    //console.log("result:"+JSON.stringify(result));
    if(success) {
      //console.log("action-result:"+JSON.stringify(data));
      commit(SET_ACCIDENTABROAD, data);
    }else{
    //  console.log("action-not-result:"+JSON.stringify(data));
      commit(SET_NOT_ACCIDENTABROAD, data);
    }
  }
  catch(err) {
    commit(FINISH_REQUEST);
    console.log(err);
  }
}
const getIndexBanner =  async ({ commit }) => {
  commit(START_REQUEST);
  const config = {
    method: 'get',
    url: 'banners/Home',
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    
    if (!success) {
      commit(FINISH_REQUEST);
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    //console.log("Banner"+JSON.stringify(result));
    commit(FINISH_REQUEST);
    commit(SET_INDEX_BANNER,result);
  }
  catch(err) {
    commit(FINISH_REQUEST);
    console.log(err);
  }
}
const getCarTypeOption = async ( { commit }, { vehicleKind, insuId }) => {
  commit(START_REQUEST);
//console.log("insuInfo_DRaction-insuId"+insuId);
  
  const token = Cookies.get('accessToken');
  const data = {
    vehicleKind,
    insuId
  }
  const config = {
    method: 'post',
    url: 'VehicleInsurance/GetVehicleTypes',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    //console.log("config_DRaction-insuId"+insuId);
    const { success, message, result } = res.data;
    const { carType } = result;
    if (!success) {
      commit(FINISH_REQUEST);
      let errorData = [];
      switch (vehicleKind) {
        case 'C':
          commit(SET_CAR_OPTION_CARTYPE, errorData);
          break;
        case 'M':
          commit(SET_MOTOR_OPTION_CARTYPE, errorData);
          break;
        default:
          break;
      }
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    commit(FINISH_REQUEST);
    switch (vehicleKind) {
      case 'C':
        commit(SET_CAR_OPTION_CARTYPE, carType);
        break;
      case 'M':
        commit(SET_MOTOR_OPTION_CARTYPE, carType);
        break;
      default:
        break;
    }
  }
  catch(err) {
    commit(FINISH_REQUEST);
    console.log(err);
  }
};
const getBrandOption = async ({ commit }, { vehicleKind, insuId, carType} ) => {
  commit(START_REQUEST);
//console.log("getBrand-insuId2:"+insuId);
  const token = Cookies.get('accessToken');
  const data = {
    vehicleKind,
    insuId,
    carType
  }
  const config = {
    method: 'post',
    url: 'VehicleInsurance/GetVehicleBrands',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    const { brand } = result;
    if (!success) {
      commit(FINISH_REQUEST);
      let errorData = [];
      switch (vehicleKind) {
        case 'C':
          commit(SET_CAR_OPTION_BRAND, errorData);
          break;
        case 'M':
          commit(SET_MOTOR_OPTION_BRAND, errorData);
          break;
        default:
          break;
      }
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    commit(FINISH_REQUEST);
    switch (vehicleKind) {
      case 'C':
        commit(SET_CAR_OPTION_BRAND, brand);
        break;
      case 'M':
        commit(SET_MOTOR_OPTION_BRAND, brand);
        break;
      default:
        break;
    }
  }
  catch(err) {
    commit(FINISH_REQUEST);
    console.log(err);
  }
}
const getCarStyleOption = async ({ commit }, { vehicleKind,insuId, carType,brand, cc,exFactoryDate} ) => {
  commit(START_REQUEST);
  //console.log("getCarStyle-insuId3:"+insuId);
  //console.log("exFactoryDate:"+exFactoryDate);
  const token = Cookies.get('accessToken');
  const data = {
    vehicleKind, 
    insuId,
    carType,
    brand,
    cc,
    exFactoryDate
  }
 
  const config = {
    method: 'post',
    url: 'VehicleInsurance/GetVehicles',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    if (!success) {
      commit(FINISH_REQUEST);
      let errorData = {
        carStyle: []
      };
      switch (vehicleKind) {
      case 'C':
        commit(SET_CAR_OPTION_CARSTYLE, errorData);
        break;
      case 'M':
        commit(SET_MOTOR_OPTION_CARSTYLE, errorData);
        break;
      default:
        break;
    }
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    commit(FINISH_REQUEST);
    switch (vehicleKind) {
      case 'C':
        commit(SET_CAR_OPTION_CARSTYLE, result);
        break;
      case 'M':
        commit(SET_MOTOR_OPTION_CARSTYLE, result);
        break;
      default:
        break;
    }
  }
  catch(err) {
    commit(FINISH_REQUEST);
    console.log(err);
  }
}

export default {
  [GET_TRAVELAREA_ACTION]: getTravelArea,
  [GET_ACCIDENTAREA_ACTION]: getAccidentArea,
  [GET_INDEX_BANNER_ACTION]: getIndexBanner,
  [GET_CARTYPE_OPTION_ACTION]: getCarTypeOption,
  [GET_BRAND_OPTION_ACTION]: getBrandOption,
  [GET_CARSTYLE_OPTION_ACTION]: getCarStyleOption,
 // [GET_CARPROFILE_ACTION]: getCarProfile,
}